import create from '@verndale/core';
import modules, { global } from './modules';
import './analytics';
import svgxhr from 'webpack-svgstore/dist/helpers/svgxhr';
import { reactModule } from './modules';

let modulesCreated = false;

svgxhr(`/Areas/SunriseSeniorLiving/images/svgsheet.svg`);

document.addEventListener('DOMContentLoaded', () => {
  if (modulesCreated) return;
  modulesCreated = true;

  global();

  create(modules).then(() => {
    create([
      {
        name: 'geolocator',
        loader: () => import('./coveo/modules/Geolocator'),
        render: reactModule
      }
    ]);
  });
});
